<template>
  <el-aside class="admin-aside client-aside" width="250px">
    <div class="aside-container">
      <div class="aside-title">
        <span>{{ title || 'My Brand' }}</span>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>CONTENT</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'products' ? 'active' : '']"
            @click="redirectTo('/client/products')"
          >
            <span>Products</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>INTEGRATION</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'instances' ? 'active' : '']"
            @click="redirectTo('/client/instances')"
          >
            <span>My Players</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>ACCOUNT</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'profile' ? 'active' : '']"
            @click="redirectTo('/client/profile')"
          >
            <span>Profile</span>
          </div>
          <!-- <div class="group-item disabled">
            <span>My Plan</span>
          </div> -->
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>SUPPORT</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'guide' ? 'active' : '']"
            @click="redirectTo('/client/guide')"
          >
            <span>Guide</span>
          </div>
          <div
            :class="['group-item', currentTab == 'integration' ? 'active' : '']"
            @click="redirectTo('/client/integration')"
          >
            <span>Integration</span>
          </div>
        </div>
      </div>
    </div>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClientSidebar',
  props: {
    title: String
  },
  data: function () {
    return {
    }
  },
  methods: {
    redirectTo: function (url) {
      this.$router.push(url)
    }
  },
  computed: {
    ...mapGetters({
      currentTab: 'currentTab'
    })
  }
}
</script>

<style scoped lang="scss">
.client-aside {
  background-color: $theme_light;
}
</style>
